import styled from "styled-components";

export const customStyles = {
  menuList: (provided) => ({
    ...provided,
    maxHeight: "250px",
    overflowY: "auto"
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "rgb(241, 241, 241)" : "white",
    color: "black",
    padding: "10px"
  }),
  singleValue: (provided) => ({
    ...provided,
    padding: "2px 0"
  })
};

export const CampaignDurationWrapper = styled.section`
  display: flex;
  text-align: left;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
`;

export const CampaignDate = styled.article`
  display: flex;
  flex-direction: column;
`;

export const CampaignDuration = styled.article`
  display: flex;
  flex-direction: column;
`;

export const CampaignLang = styled.article`
  display: flex;
  flex-direction: column;
`;

export const WrapHeadline = styled.h3`
  color: #37517ed1;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 0;
  font-size: 14px;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

export const InputWrapper = styled.div`
  color: ${({ activate }) => (activate ? "#8893af" : "#b2bedc")};
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
`;

export const GeneralInput = styled.input`
  cursor: pointer;
  + label {
    cursor: pointer;
  }
`;

export const InputDate = styled(GeneralInput)`
  margin-left: 10px;
  border-radius: 3px;
  padding: 3px;
  color: #607d8b;
  border: 0;
`;

export const SelectContainer = styled.div`
  display: inline-block;
  width: 150px;
`;

export const CustomSelect = styled.select`
  width: 100%;
  padding: 8px;
  padding-right: 30px;
  appearance: none;
  border: 1px solid #4e4f87;
  border-radius: 4px;
  background: white;
  font-size: 13px;
  cursor: pointer;

  background-image: none;
`;

export const ArrowIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  pointer-events: none;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
`;
